import { render } from "./searchVideo.vue?vue&type=template&id=47a1d9ec"
import script from "./searchVideo.vue?vue&type=script&lang=js"
export * from "./searchVideo.vue?vue&type=script&lang=js"

import "./searchVideo.vue?vue&type=style&index=0&id=47a1d9ec&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__